// @ts-nocheck
import './swiper-bundle.min.js';

export class CommonSwiper extends HTMLElement {
  // 函数返回避免数据共享
  static config = () => ({
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
      1240: {
        spaceBetween: 32,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  constructor() {
    super();
    this.only_mobile = this.hasAttribute("only-mobile");
    this.only_desktop = this.hasAttribute("only-desktop");
  }

  connectedCallback() {
    if (this.only_mobile && window.innerWidth > 768) return;
    if (this.only_desktop && window.innerWidth < 768) return;
    this.container = this.querySelector(".swiper");
    if (!this.container) return;
    if (!this.querySelectorAll(".swiper-slide")?.length) return;

    this.initConfig();
  }

  initConfig() {
    this.config = this.getConfig();

    if (this.hasAttribute("thumbnail")) {
      this.config.thumbs = {};
      const thumbnailElement = document.querySelector(this.getAttribute("thumbnail") || "");
      if ((thumbnailElement?.hasAttribute("only-mobile") && window.innerWidth > 768) || (thumbnailElement?.hasAttribute("only-desktop") &&window.innerWidth < 768)) {
        this.initSwiper();
        return;
      }
      if ((/** @type {any} */(thumbnailElement))?.swiper) {
        this.thumbnailSwiper = (/** @type {any} */(thumbnailElement))?.swiper;
        this.config.thumbs.swiper = (/** @type {any} */(thumbnailElement))?.swiper;
        this.initSwiper();
      } else {
        thumbnailElement?.addEventListener(
          "swiper-init",
          (e) => {
            const swiper = /** @type {CustomEvent} */(e).detail;
            this.thumbnailSwiper = swiper;
            this.config.thumbs.swiper = swiper;
            this.initSwiper();
          },
        );
      }
    } else {
      this.initSwiper();
    }
  }

  initSwiper() {
    if (!this.config.on) this.config.on = {};
    if (!this.config.on.init) {
      this.config.on.init = function (/** @type {any} */ swiper) {
        this.dispatchEvent(new CustomEvent("swiper-init", { detail: swiper }));
        if (this.initCallback) this.initCallback(swiper);
      }.bind(this);
    }
    // @ts-ignore
    this.swiper = new Swiper(this.container, this.config);

    if (window.innerWidth < 768) return;
    if (
      this.querySelector(".left-swiper") &&
      this.querySelector(".right-swiper")
    ) {
      // @ts-ignore
      this.leftSwiper = new Swiper(this.querySelector(".left-swiper"), {
        loop: true,
        simulateTouch: false,
      });
      // @ts-ignore
      this.rightSwiper = new Swiper(this.querySelector(".right-swiper"), {
        loop: true,
        simulateTouch: false,
      });

      this.swiper.controller.control = [this.leftSwiper, this.rightSwiper];
    }
  }

  getConfig() {
    let config = JSON.parse(this.querySelector("script[data-swiper-config]")?.textContent || "null") || null;
    config = config || CommonSwiper.config();
    // 格式化函数类型
    if (config?.on) {
      config.on = this.formatFunction(config.on);
    }

    if (config?.breakpoints) {
      for (let key in config.breakpoints) {
        if (config.breakpoints[key]?.on) {
          config.breakpoints[key].on = this.formatFunction(config.breakpoints[key].on);
        }
      }
    }

    if (config.navigation) {
      // 判断config.navigation.nextEl是dom对象还是字符串
      if (typeof config.navigation.nextEl === "string") {
        config.navigation.nextEl = this.querySelector(
          config.navigation.nextEl,
        );
      }
      if (typeof config.navigation.prevEl === "string") {
        config.navigation.prevEl = this.querySelector(
          config.navigation.prevEl,
        );
      }
    }
    if (config.scrollbar && config.scrollbar.el) {
      config.scrollbar.el = this.querySelector(config.scrollbar.el);
    }

    if (
      this.querySelector(".swiper-pagination") ||
      this.closest(".swiper-father")?.querySelector(".swiper-pagination")
    ) {
      config.pagination = {
        el:
          this.querySelector(".swiper-pagination") ||
          this.closest(".swiper-father")?.querySelector(".swiper-pagination"),
        clickable: true,
      };
    } else {
      delete config.pagination;
    }

    return config;
  }

  /**
   * @param {Record<string, string>} oldOn
   * 
   */
  formatFunction(/** @type {Record<string, string>} */oldOn) {
    const newOn = /** @type {Record<string, any>} */{};
    Object.keys(oldOn).forEach((key) => {
      if (oldOn[key]) {
        newOn[key] = new Function("return " + oldOn[key])();
      }
    });
    return newOn;
  }

  disconnectedCallback() {
    if ('finishCallback' in this && typeof this.finishCallback === 'function') this.finishCallback();
    this.swiper?.destroy();
  }
}

if (!customElements.get('common-swiper')) {
  customElements.define('common-swiper', CommonSwiper);
}

customElements.define('meta-fixel', class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.contentCategory = this.getAttribute('data-content-category');
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      console.log("track: CompleteRegistration", this.contentCategory);
      this.contentCategory ? fbq('track', 'CompleteRegistration', { content_category: this.contentCategory }) : fbq('track', 'Subscribe');
    });
  }
});